// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageBody-modulechatroomMessageBody__jbhQC";
var _2 = "ChatroomMessageBody-modulechatroomMessageBodyOwn__B1Hfa";
var _3 = "ChatroomMessageBody-modulechatroomMessageBodyPrivate__Ffjbp";
var _4 = "ChatroomMessageBody-moduletext__ZLndS Text-moduletext__Z2j5F";
var _5 = "ChatroomMessageBody-moduletextEdited__P8vbO";
var _6 = "ChatroomMessageBody-moduletextWrap__ECgIA";
export { _1 as "chatroomMessageBody", _2 as "chatroomMessageBodyOwn", _3 as "chatroomMessageBodyPrivate", _4 as "text", _5 as "textEdited", _6 as "textWrap" }
